<h4 class="small bold text-primary text-uppercase mb-4">Today's plan</h4>
<prx-vertical-timeline-basic [items]="tasks" editable="true"></prx-vertical-timeline-basic>
